export { Img } from './Img';
export type { Props as ImgProps } from './Img';
